import { type Treaty, treaty } from '@elysiajs/eden';
import type { Api } from 'realtiq-api/src/routes';

import { env } from '@/constants/env';

import { customFetch } from './fetch-interceptor';

export const api = treaty<Api>(env.API_URL, {
  fetcher(url, options) {
    return customFetch(url, options);
  },
});

export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
  }
}

export const extractData = async <T extends Record<number, unknown>>(
  promise: Promise<Treaty.TreatyResponse<T>>
) => {
  const { data, error } = await promise;

  if (!data) {
    const message =
      error && typeof error?.value === 'string' ? error.value : 'Something went wrong';

    if (error) throw new ApiError(message, Number(error.status));

    throw new Error(message);
  }

  return data;
};
